import React from 'react';
import { Megaphone, Newspaper, Star } from 'lucide-react';

/**
 * „Was möglich ist" auf `/fuer-partner`. Die Seite war seit dem 04.09.2026 nur Hero plus
 * Kontakt-Knopf; wer sie öffnete, musste raten, worüber er eigentlich anfragt.
 *
 * Bewusst kurze Karten statt einer Preisliste: die Platzierungen für Marken werden einzeln
 * verhandelt, und eine Zahl auf dieser Seite wäre eine zweite Wahrheit neben `price_items`.
 * Beschrieben ist, was es wirklich gibt — die drei Plätze aus `docs/werbung-spezifikation.md`.
 *
 * Die drei sind Beispiele, keine Liste zum Abhaken: der Kasten darunter sagt das ausdrücklich,
 * sonst liest sich die Seite wie ein geschlossenes Sortiment und eine Anfrage nach etwas anderem
 * kommt gar nicht erst.
 *
 * Eigene Komponente, damit der Abschnitt im Design-Lab steht, ohne die Seite samt Kontakt-Dialog
 * einzuhängen.
 */
const FONT_DISPLAY = "'Archivo',sans-serif";
const FONT_BODY = "'Hanken Grotesk',sans-serif";
const FONT_MONO = "'Space Mono',monospace";

const PLACEMENTS = [
  {
    icon: Megaphone,
    title: 'Banner über den Terminen',
    text: 'Der Streifen über dem Event-Raster, auf der Startseite und auf jeder Ergebnisseite. Text, Logo und Link werden im Layout der Seite gesetzt, Sie brauchen keine fertige Werbegrafik.',
  },
  {
    icon: Star,
    title: 'Hervorgehobenes Event',
    text: 'Ihr Event fällt im Kalender auf, an seinem Termin und nicht weiter oben. Als Rahmen, als dunkle Karte oder als Bühne über beide Spalten mit Foto.',
  },
  {
    icon: Newspaper,
    title: 'Beitrag im News-Bereich',
    text: 'Ein eigener Artikel, als Anzeige gekennzeichnet und mit Ihren Events verknüpft. Er steht dann auch auf deren Event-Seiten unter „Berichte".',
  },
];

const PartnerPlacements: React.FC = () => (
  <section style={{ marginTop: 56 }}>
    <span style={{ fontFamily: FONT_MONO, fontSize: 11, letterSpacing: '0.16em', color: '#9A9494' }}>{'// WAS MÖGLICH IST'}</span>
    <h2 style={{ fontFamily: FONT_DISPLAY, fontWeight: 800, fontSize: 30, letterSpacing: '-0.01em', color: '#2C2C2C', margin: '10px 0 8px' }}>
      Wo Ihre Marke stehen kann
    </h2>
    <p style={{ fontFamily: FONT_BODY, fontSize: 16, lineHeight: 1.5, color: '#6A6A6A', margin: '0 0 26px', maxWidth: 640 }}>
      Diese drei Formen gibt es heute schon. Laufzeit und Umfang legen wir je Platzierung fest, von einem einzelnen Termin bis zur ganzen Saison.
    </p>

    <div className="fp-cards">
      {PLACEMENTS.map(({ icon: Icon, title, text }) => (
        <div key={title} style={{ background: '#fff', border: '1px solid #E5E1E1', borderRadius: 14, padding: 22 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, borderRadius: 12, background: '#FCF5F8' }}>
            <Icon size={20} strokeWidth={1.9} color="#922C57" aria-hidden />
          </span>
          <h3 style={{ fontFamily: FONT_DISPLAY, fontWeight: 800, fontSize: 18, color: '#2C2C2C', margin: '14px 0 6px' }}>{title}</h3>
          <p style={{ fontFamily: FONT_BODY, fontSize: 14.5, lineHeight: 1.5, color: '#6A6A6A', margin: 0 }}>{text}</p>
        </div>
      ))}
    </div>

    <div style={{ marginTop: 18, background: '#FCF5F8', border: '1px solid #F0DCE5', borderRadius: 14, padding: '18px 22px' }}>
      <p style={{ fontFamily: FONT_BODY, fontSize: 15.5, lineHeight: 1.5, color: '#4A4A4A', margin: 0 }}>
        <strong style={{ color: '#2C2C2C' }}>Sie haben etwas anderes vor?</strong>{' '}
        Eine Sonderplatzierung, eine Kooperation über eine ganze Saison, ein Format, das es hier
        noch nicht gibt: Sagen Sie uns, was Sie erreichen wollen, und wir sehen, wie es auf die
        Seite passt.
      </p>
    </div>
  </section>
);

export default PartnerPlacements;
